import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CashTrackingCashMovementsPage } from 'src/app/modals/cash-tracking-cash-movements/cash-tracking-cash-movements.page';

const routes: Routes = [
  {
    path: '',
    component: CashTrackingCashMovementsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CashTrackingCashMovementsPage]
})
export class CashTrackingCashMovementsPageModule {}
